<div id="modalrooms" style="position: relative;">
  <div id="modalRooms">
          <div class="modal-content pt-5 px-3" style="padding-bottom: 50px;">
            <div class="d-flex justify-content-between mx-auto" style="width: 97%">

                <h1 class="title mb-0 mt-2" style="line-height: 1 !important; color: black !important;">
                  {{ insurance?.plan?.planName }}
                </h1>


              <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
                <span aria-hidden="true" style="font-size: 50px; font-weight: 100;">&times;</span>
              </button>
          </div>
      <usb-comments
          [clientSetting]="clientSetting"
          [payload]="payload"
          [productId]="insurance.planId"
        >
        </usb-comments>
    </div>

</div>
